<template>
    <div id="scorePanel" class="AssignmentScore">
        <div class="scoreQuestion">
            <span>Vraag</span><span id="QuestionNrLabel" class="total">{{convertToThreeDigits(questionNumber)}}</span>
        </div>
        <div class="scoreQuestionTotal">
            <span>van</span><span id="QuestionCountLabel" class="total">{{convertToThreeDigits(questionCount)}}</span>
        </div>
        <div class="scoreScore">
            <span>Score</span>
            <span id="ScoreRightLabel" class="right">{{convertToThreeDigits(scoreRight)}}</span>
            <span id="ScoreWrongLabel" class="wrong">{{convertToThreeDigits(scoreWrong)}}</span>
        </div>
    </div>
</template>

<script>
    import be from '../services/Backend';
    import Auth from '../services/Auth';


    export default {
        'props': ['scoredata'],
        'data': () =>
        {
            return {
                questionNumber: 0,
                questionCount: 0,
                scoreRight: 0,
                scoreWrong: 0,
            }
        },
        'watch': {
            scoredata: function() {
                this.scoreRight = this.scoredata.correct;
                this.scoreWrong = this.scoredata.incorrect;
                this.questionNumber = this.scoredata.questionNumber;
                this.questionCount = this.scoredata.questionCount;
            }
        },
        'methods': {
            convertToThreeDigits: function(number) {
                return ('000' + number).substr(-3);
            }
        }
    };
</script>
